import { Box, Stack, Text } from '@mantine/core';
import { DetailCard, type WaRendererProps } from './primitives';

/** Shared contact card(s), capped at three with a "+N more" tail. */
export function ContactsCard({ view }: WaRendererProps) {
  const contacts = view.contacts;
  if (!contacts) return null;
  return (
    <DetailCard>
      <Stack gap={6}>
        {contacts.slice(0, 3).map((c, i) => (
          <Box key={i}>
            <Text size="xs" fw={600}>
              👤 {c.name}
            </Text>
            {c.phones.map((ph) => (
              <Text key={ph} size="xs" c="dimmed">
                {ph}
              </Text>
            ))}
          </Box>
        ))}
        {contacts.length > 3 && (
          <Text size="xs" c="dimmed">
            +{contacts.length - 3} more
          </Text>
        )}
      </Stack>
    </DetailCard>
  );
}
